import type { FaireProductEntity } from "../../entity_types/product";

export const p_ntnu3hfa6h: FaireProductEntity = {
  token: "p_ntnu3hfa6h",
  type: "product",
  name: "Maneki Neko Japanese Washi Stickers JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/b006b8b4afaf3e692b7a2285b12fd8c59c8c4f95fc3e6c73c205167d30352e84.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a410e3b72e4eed4b4ddcc47760c058e99ebd3a34df1df51c8b85159f4ae2fa79.jpeg",
    "https://cdn.faire.com/fastly/269fbbf6726bde4f3e2a6131a9da0e377eeb2a66f0f8f7fab246bfbeffa6ad70.jpeg"
  ],
  priceDollars: 2,
  description: "Add a touch of Japan to cards, gift wrap and journals with these Maneki Neko washi stickers. Made in Japan, they make an easy add-on for gift shops and checkout counters, and a fun souvenir for fans of Japanese design.\n\nFeatures\n\n * Japanese washi stickers: a classic Japanese craft item for scrapbooks, planners, letters and gift wrap \n * Collect the series: also available in Sakura, Warlord, Origami, O-Gi Fan, Japanese Foods, Origami Cranes, Ukiyo Mt. Fuji \nSpecifications\n\n * Type: Washi stickers \n * Design: Maneki Neko \n * Inner pack: 1 \n * Case pack: 100 \n * Origin: Japan ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:55.786Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
